
import { getPrizeTicketDtl } from "@/api/couponManage";
import Vue from "vue";
import { Component } from "vue-property-decorator";
import { Getter } from "vuex-class";
import CouponDetail from "./components/couponDetail.vue";
import { pxToVw } from "@/utils/pxToVw";

@Component({
  name: "PackageSelector",
  components: { CouponDetail },
})
export default class couponManage extends Vue {
  @Getter companyId!: string;
  @Getter bottomSafetyHeight!: number;
  showClassify = false;
  showRules = false;
  get bottomSafetyHeightVw(): string {
    return this.bottomSafetyHeight ? pxToVw(this.bottomSafetyHeight) : pxToVw(12);
  }

  prizeTicketList = [];
  isBatch = false;
  params = {
    pageIndex: 1,
    pageSize: 10,
    prizeTicketId: "",
    statusType: '',
  };
  statusOptions = [
    {
      title: '全部',
      id: '',
    },
    {
      title: '未领取',
      id: '1',
    },
    {
      title: '已领取',
      id: '2',
    },
    {
      title: '已核销',
      id: '3',
    },
    {
      title: '已过期',
      id: '4',
    },
    {
      title: '已作废',
      id: '5',
    }
  ]
  statusName = '全部状态'
  // 临时存储弹窗选择的筛选条件
  tempParams: any = {
    statusType: 0,
  };
  couponDetail: any = {}
  loading = false;
  finished = false;
  refreshing = false;
  mounted() {
    this.params.prizeTicketId = this.$route.query.prizeTicketId as string
    this.tempParams = { ...this.params };
    this.getPrizeTicketDtl();
  }

  onLoad() {
    this.params.pageIndex++;
    this.getPrizeTicketDtl();
  }

  onRefresh() {
    this.params.pageIndex = 1;
    this.refreshing = true;
    this.getPrizeTicketDtl();
  }

  // 获取详情数据
  getPrizeTicketDtl() {
    getPrizeTicketDtl({
      storeId: this.companyId,
      ...this.params
     })
      .then((res) => {
        console.log(res)
        this.couponDetail = res.data || {}
        if (this.refreshing || this.params.pageIndex === 1) {
          this.prizeTicketList = []
        }
        this.prizeTicketList = this.prizeTicketList.concat(res.data.prizeTicketList.records)
        if (this.params.pageIndex >= res.data.prizeTicketList.totalPages) {
          this.finished = true;
        } else {
          this.finished = false;
        }
        this.loading = false;
        this.refreshing = false;
      }).catch(() => {
        this.finished = true;
      })
      .finally(() => {
        this.loading = false;
      });
  }

  selectOption (id:any) {
    this.params.pageIndex = 1;
    this.tempParams.statusType = id;
  }

  popupClose() {
    this.showClassify = false
  }
  popupOpen() {
    this.showClassify = true;
    this.tempParams = {
      statusType: this.params.statusType
    };
  }
  onSearch() {
    console.log(this.params.statusType)
    this.showClassify = false
    this.params.statusType = this.tempParams.statusType;
    if (this.params.statusType === ''){
      this.statusName = '全部状态'
    } else {
      this.statusName = this.statusOptions[this.params.statusType].title
    }
    this.getPrizeTicketDtl();
  }
  onCancelClassify() {
    this.onSearch();
  }
}
